import { ActionTree } from 'vuex';
import { AuthState, RootState } from '@/store/types';
import { ICast } from '@/types/cast';
import { IGuest } from '@/types/guest';
import router from '@/router';
import { auth } from '@/plugins/firebase';
import { onAuthStateChanged, signOut } from "firebase/auth";

const actions: ActionTree<AuthState, RootState> = {
    registerUserInfo({ commit }, user) {
        commit('registerUserInfo', user);
    },
    clearUserInfo({ commit }) {
        commit('clearUserInfo');
    },
    getDetailInfo({ commit }) {
        commit('getDetailInfo');
    },
    setDetailInfo({ commit }, userInfo: ICast | IGuest | null) {
        commit('setDetailInfo', userInfo);
    },
    onAuth({ commit }) {
        onAuthStateChanged(auth, async (user) => {
            await commit("setUid", user?.uid);
        });
    },
    async signOut({ commit, dispatch }, redirect_path?: string) {
        signOut(auth).then(async () => {
            await commit("clearUserInfo");
            await dispatch("userData/clearUserData", null, { root: true });
            if (redirect_path) {
                router.push(redirect_path);
            }
        })
            .catch(async (e) => {
                console.log(e);
                await commit("clearUserInfo");
                if (redirect_path) {
                    router.push(redirect_path);
                }
            });

    }
};

export default actions;